import { lazy, Suspense, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useProfileLocationPromptStore } from '@/stores/profileLocationPromptStore'

const ProfileLocationDialog = lazy(() => import('@/components/ProfileLocationDialog').then(m => ({ default: m.ProfileLocationDialog })))

export function ProfileLocationPrompt() {
  const request = useProfileLocationPromptStore(state => state.request)
  const finish = useProfileLocationPromptStore(state => state.finish)
  const { pathname } = useLocation()
  const openedOn = useRef<string | null>(null)

  // The page that asked is gone once the route changes, so its registration must not resume.
  useEffect(() => {
    if (!request) {
      openedOn.current = null
    } else if (openedOn.current === null) {
      openedOn.current = pathname
    } else if (openedOn.current !== pathname) {
      finish(null)
    }
  }, [finish, pathname, request])

  if (!request) return null
  return (
    <Suspense fallback={null}>
      <ProfileLocationDialog key={`${request.sid}-${request.missingFields.join()}`} request={request} />
    </Suspense>
  )
}
